import React from 'react';
import OrderService from '../services/order.js';
import SimpleOrderItem from './simpleOrderItem';
import $ from 'jquery';
import AuthorizationCheck from '../auth/authorizationCheck.js';
import CountryService from '../services/country';

class NewCountryOrder extends React.Component {

    constructor(props) {

        super(props);



        this.state = {
            orders: [],
            currentUserRole: '',
            countries: [],
        }

        this.countryService = new CountryService();

    }

    componentDidMount() {

        this.orderList();
        this.countries();

    }

    countries = async () => {

        const res = await this.countryService.fetchCountries();

        this.setState({ countries: await res.json() });

    }

    orderList = async () => {

        try {

            let countryId = $('#countryId').val();
            const response = await OrderService.newOrders(countryId);

            if (response.status == 200) {

                this.setState({ orders: await response.json() });
            } else {

                this.setState({ orders: [] });
            }


        } catch (error) {

            console.log(error);
        }


    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    render() {

        const orders = this.state.orders;

        if (orders != undefined) {

            //localStorage.setItem('selectedOrder', order.orderId);
        }



        const countries = this.state.countries;



        let countrySelection = '';



        if (this.state.currentUserRole == 'MANAGER' || this.state.currentUserRole == 'SUPER-ADMIN') {


            countrySelection = <div className="row">
                <div className="form-wrapper">
                    <div className="form-group">
                        <label className="label">Choisi le Pays</label>
                        <select className="form-control" id="countryId" onChange={this.orderList} >
                            <option></option>
                            {countries.length > 0 && countries.map(country =>

                                <option value={country.countryId}>{country.name}</option>
                            )}
                        </select>
                    </div>
                </div>
            </div>
        }

        return (

            <div className="order-wrapper">

                <AuthorizationCheck accessLevel='USER' userRole={this.setRole} />

                <h2>Nouvelles Commandes</h2>


                <div className="container ordersHolder">

                    {countrySelection}

                    <div className="message-holder"></div>

                    {orders != undefined && orders.length > 0 && orders.map(order =>

                        <SimpleOrderItem key={order.orderId} order={order} />
                    )}











                </div>

            </div>

        );
    }


}

export default NewCountryOrder;